import { defineStore } from 'pinia'
import axios from 'axios'
import { useRoute, useRouter } from 'vue-router'

export const useLocalizationStore = defineStore('LocalizationStore', {
    state: () => {
        return {
            localization: null,
            defaultLanguage: "en",
            route: useRoute(),
            router: useRouter(),
        }
    },
    persist: {
        paths: ['localization'],
        debug: false
    },
    actions: {
        async getLanguage() {
            const route = this.router.resolve(
                {
                    name: 'localization'
                }
            );
            try {
                this.localization = await axios.get(route.href)
                .then(function (response) {
                    return response.data;
                });
                // this.userData = await api.post({ login, password })
            } catch (error) {
                console.log(error);
            }
        },
    },
    getters: {
        translate: (state) => {
            return (key, dynamicValues = {}) => {
                if (state.localization) {
                    let message = state.localization[state.defaultLanguage].locale[key] ? state.localization[state.defaultLanguage].locale[key] : null;
                    if (Object.keys(dynamicValues).length > 0 && message != null) {
                        Object.entries(dynamicValues).forEach(
                            ([key, value]) => {
                                message = message.replace(`:${key}`, value);
                            }
                        );
                        return message;
                    }
                    return message;
                }
                return null;
            }
        },
    },
})